<div [class]="'page-header ' + getPageHeader()">
  <div [ngStyle]="{backgroundImage: 'url('+headerImage+')'}" [class]="'banner ' + classModifierForWhitelabel"></div>
  <ng-content *ngIf="bannerBrighter" select="[slot=logo]"></ng-content>
  <div class="app-title">{{"APP.TITLE" | translate}}</div>
  <div class="app-subtitle">
    <ng-content select="[slot=subtitle]"></ng-content>
  </div>
</div>
